import React, {Component} from 'react';
import {Link} from 'react-router-dom'
import ReportSoggettiRowView from '../report/ReportSoggettiRowView'
import ModalConfirm from '../ModalConfirm'

class RubricaScrollableRow extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {


        if (this.props.item === null || this.props.item === undefined){
            return (
                <div className="ui grid">
                    <div className="row">
                        <div className="ui one column centered grid">
                            <div className="center aligned one column row">
                                <div className="column">
                                    <h4>Nessun soggetto visualizzabile</h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }

        let c = {
            soggetto: this.props.item,
            dipartimento: this.props.item.idDipartimento,
            organizzazione: this.props.item.idDipartimento.idOrganizzazione,
        }

        let btnEdit = null;
        let btnDelete = null;
        if (this.props.readOnly === false){
            btnEdit = <Link  className="ui blue icon button" to={`/app/rubrica/edit/${c.soggetto.idSoggetto}`}>
                            <i
                                className="edit icon"

                            ></i> Modifica
                        </Link>;
            btnDelete = <ModalConfirm
                            msg={"Stai per cancellare il soggetto: " + c.soggetto.nomeCompleto}
                            onClickOk={(ev) => (this.props.onDeleteSoggetto(ev, c.soggetto))}
                        >
                            <a className="ui red icon button"><i className="trash icon"/> Elimina</a>
                        </ModalConfirm>;
        }
        return (
            <div className="ui grid">
                <div className="row">
                    <div className="ui one column centered grid">
                        <div className="center aligned one column row">
                            <div className="column detaildataitem">
                                {/*<RubricaDetail loading={false} item={c} showButtons={false} />*/}
                                <ReportSoggettiRowView item={this.props.item}/>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row no-print">
                    <div className="ui one column grid">

                        <div className="center aligned column">
                            {this.props.canAddSoggetto ?
                                <a className="ui light grey icon button" onClick={(ev) => (this.props.onAddSoggetto(ev, c.soggetto))}>
                                    <i className="square outline icon"/> Aggiungi alla lista dei Sender
                                </a>
                                :
                                <a className="ui blue icon button">
                                    <i className="check icon"/> Aggiunto alla lista dei sender
                                </a>
                            }
                            {btnEdit}
                            {btnDelete}
                        </div>

                    </div>
                </div>
            </div>)
    }
}

export default RubricaScrollableRow;




/** WEBPACK FOOTER **
 ** ./src/components/rubrica/RubricaScrollableRow.js
 **/